module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-container', {
    attrs: {
      "fluid": "",
      "grid-list-md": "",
      "pa-0": _vm.$vuetify.breakpoint.xsOnly
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [(_vm.dadosMatricula.matricula.temPreencherPolo) ? _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('h4', {
    staticClass: "title mb-3"
  }, [_vm._v("Selecione o polo")]), _vm._v(" "), _c('v-card', {
    attrs: {
      "flat": "",
      "color": "grey lighten-4 mb-3",
      "mx-0": ""
    }
  }, [_c('v-card-text', {
    staticClass: "pa-3"
  }, [(_vm.dadosMatricula.matricula.polos.length) ? [_c('v-radio-group', {
    staticClass: "mt-0",
    attrs: {
      "hide-details": ""
    },
    model: {
      value: (_vm.dadosMatricula.matricula.ref_polo),
      callback: function($$v) {
        _vm.$set(_vm.dadosMatricula.matricula, "ref_polo", $$v)
      },
      expression: "dadosMatricula.matricula.ref_polo"
    }
  }, _vm._l((_vm.dadosMatricula.matricula.polos), function(polo, index) {
    return _c('v-radio', {
      key: index,
      attrs: {
        "color": "secondary",
        "value": polo.id
      }
    }, [_c('div', {
      attrs: {
        "slot": "label"
      },
      slot: "label"
    }, [_vm._v(_vm._s(polo.descricao))])])
  }), 1)] : [_vm._v("\n              Nenhum polo disponível para seleção.\n            ")]], 2)], 1)], 1) : _vm._e(), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('h4', {
    staticClass: "title mb-3"
  }, [_vm._v("Leia atentamente o contrato abaixo")]), _vm._v(" "), _c('v-card', {
    staticClass: "scroll-y",
    attrs: {
      "height": "300",
      "color": "grey lighten-4",
      "id": "scroll-target"
    }
  }, [_c('v-card-text', {
    ref: "contratoCardScroll",
    staticClass: "justify-center",
    domProps: {
      "innerHTML": _vm._s(_vm.textoContrato)
    }
  })], 1)], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "align-center": "",
      "justify-start": ""
    }
  }, [_c('div', {
    staticClass: "pl-2"
  }, [_c('v-checkbox', {
    staticClass: "my-0",
    attrs: {
      "color": "secondary",
      "label": "Confirmo que li e aceito os termos do contrato acima"
    },
    model: {
      value: (_vm.dadosMatricula.matricula.aceito_termos),
      callback: function($$v) {
        _vm.$set(_vm.dadosMatricula.matricula, "aceito_termos", $$v)
      },
      expression: "dadosMatricula.matricula.aceito_termos"
    }
  }), _vm._v(" "), (_vm.dadosMatricula.matricula.ref_disciplina_cpp && this.dadosMatricula.matricula.contrato.cpp.turma_virtual === 't') ? _c('v-checkbox', {
    staticClass: "my-0",
    attrs: {
      "color": "secondary",
      "label": "Declaro que estou ciente que a cpp (EXP3) é virtual e não possui encontros presenciais, somente online."
    },
    model: {
      value: (_vm.dadosMatricula.matricula.ciente_nao_trocar_cpp),
      callback: function($$v) {
        _vm.$set(_vm.dadosMatricula.matricula, "ciente_nao_trocar_cpp", $$v)
      },
      expression: "dadosMatricula.matricula.ciente_nao_trocar_cpp"
    }
  }, [_c('span', [_vm._v("cpp virtual")])]) : _c('v-checkbox', {
    staticClass: "my-0",
    attrs: {
      "color": "secondary",
      "label": "Estou ciente que não poderei alterar a CPP depois da confirmação da matrícula"
    },
    model: {
      value: (_vm.dadosMatricula.matricula.ciente_nao_trocar_cpp),
      callback: function($$v) {
        _vm.$set(_vm.dadosMatricula.matricula, "ciente_nao_trocar_cpp", $$v)
      },
      expression: "dadosMatricula.matricula.ciente_nao_trocar_cpp"
    }
  }, [_c('span', [_vm._v("cpp virtual")])])], 1)])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "flex-header"
  }, [_c('navigation-buttons', {
    attrs: {
      "show-previous": true,
      "show-next": true,
      "previous-click": _vm.voltar,
      "next-click": _vm.salvarDados,
      "disable-next": ((_vm.dadosMatricula.matricula.ref_disciplina_cpp ? _vm.$v.dadosMatricula.$invalid : !_vm.dadosMatricula.matricula.aceito_termos) || (_vm.dadosMatricula.matricula.temPreencherPolo && !_vm.dadosMatricula.matricula.ref_polo))
    }
  })], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-d9b4d4f8!./~/vue-loader/lib/selector.js?type=template&index=0!./src/app/domains/dashboard/matricula_online/Contrato.vue
// module id = 579
// module chunks = 2